export default __webpack_public_path__ + "static/media/web-programming.4bd97abe.svg";